import i18n from 'i18n'
import Vue from 'vue'
import VueRouter from 'vue-router'
import { stringify } from 'qs'
import { getVisitByShareId } from '@/services/api'
import dayjs from 'dayjs'
// Error: Redirected when going from “/a“ to “/b“ via a navigation guard.
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    redirect: '/robot',
  },
  {
    path: '/user',
    name: 'User',
    component: () => import('@/views/user'),
    beforeEnter(to, from, next) {
      if (localStorage.getItem('user') !== 'undefined' && localStorage.getItem('user') != null) {
        next()
      } else {
        next('/login')
      }
    },
  },
  {
    path: '/reg',
    name: 'Reg',
    component: () => import('@/views/reg'),
    meta: { title: i18n.t('注册') },
  },
  {
    path: '/demo',
    name: 'Demo',
    component: () => import('@/views/home'),
  },
  {
    path: '/setPwd/:mobile?',
    name: 'SetPwd',
    component: () => import('@/views/setPwd'),
    meta: { title: i18n.t('设置密码') },
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login'),
    meta: { title: i18n.t('登录') },
  },
  {
    path: '/findPwd',
    name: 'FindPwd',
    component: () => import('@/views/findPwd'),
    meta: { title: i18n.t('忘记密码') },
  },
  {
    path: '/robot',
    name: 'Robot',
    meta: { title: i18n.t('机器人前台') },
    component: () => import('@/views/robot/index'),
    beforeEnter(to, from, next) {
      let companyCode = { code: to.query.companyCode }
      localStorage.setItem('companyCode', JSON.stringify(companyCode))
      if (to.query.corpId) {
        localStorage.setItem('corpid', JSON.stringify({ id: to.query.corpId }))
      }
      if (to.query.code) {
        localStorage.setItem('code', JSON.stringify({ code: to.query.code }))
      }
      if (to.query.state) {
        localStorage.setItem('state', JSON.stringify(to.query.state))
      }
      if (to.query.type) {
        localStorage.setItem('type', JSON.stringify(to.query.type))
      }
      if (to.query.appId) {
        localStorage.setItem('appId', JSON.stringify(to.query.appId))
      }

      if (to.query.appointmentId) {
        let appointmentId = { id: to.query.appointmentId }
        localStorage.setItem('appointmentId', JSON.stringify(appointmentId))
      }

      if (localStorage.getItem('user') !== 'undefined' && localStorage.getItem('user') != null) {
        next()
      } else {
        next(`/login?${stringify(to.query)}`)
      }
    },
  },
  {
    path: '/meeting',
    name: 'Meeting',
    meta: { title: i18n.t('会议预约') },
    component: () => import('@/views/meeting'),
    // beforeEnter(to, from, next) {
    //   let companyCode = { code: to.query.companyCode }
    //   let appointmentId = { id: to.query.appointmentId }
    //   localStorage.setItem('companyCode', JSON.stringify(companyCode))
    //   localStorage.setItem('appointmentId', JSON.stringify(appointmentId))
    //   if (localStorage.getItem('user') !== 'undefined' && localStorage.getItem('user') != null) {
    //     next()
    //   } else {
    //     if (to.query.corpId) {
    //       localStorage.setItem('corpid', JSON.stringify({ id: to.query.corpId }))
    //     }
    //     if (to.query.code) {
    //       localStorage.setItem('code', JSON.stringify({ code: to.query.code }))
    //     }
    //     next('/login')
    //   }
    // },
  },
  {
    path: '/setting',
    name: 'Setting',
    component: () => import('@/views/setting'),
    meta: { title: i18n.t('设置') },
    beforeEnter(to, from, next) {
      if (localStorage.getItem('user') !== 'undefined' && localStorage.getItem('user') != null) {
        next()
      } else {
        next('/login')
      }
    },
  },
  {
    path: '/signIn',
    name: 'SignIn',
    component: () => import('@/views/signIn'),
  },
  {
    path: '/meeting-sign',
    name: 'SignIn',
    component: () => import('@/views/signIn'),
  },
  {
    path: '/changePwd',
    name: 'ChangePwd',
    component: () => import('@/views/changePwd'),
    meta: { title: i18n.t('修改密码') },
    beforeEnter(to, from, next) {
      if (localStorage.getItem('user') !== 'undefined' && localStorage.getItem('user') != null) {
        next()
      } else {
        next('/login')
      }
    },
    beforeRouteLeave(to, from, next) {
      if (this.$route.query.isFirstLogin == 'true') {
        return
      }
      next()
    },
  },
  {
    path: '/bookMeetings',
    name: 'BookMeetings',
    meta: { title: i18n.t('我的预约') },
    component: () => import('@/views/bookMeetings'),
  },
  {
    //会议签到
    path: '/mettingAttendance',
    name: 'MettingAttendance',
    meta: { title: i18n.t('签到') },
    component: () => import('@/views/mettingAttendance'),
  },
  {
    //会议详情
    path: '/mettingInfor',
    name: 'MettingInfor',
    meta: { title: i18n.t('会议详情') },
    component: () => import('@/views/meetingInfor'),
  },
  {
    //会议详情时间已过
    path: '/mettingInforRead',
    name: 'MettingInforRead',
    meta: { title: i18n.t('会议详情') },
    component: () => import('@/views/meetingInforRead'),
  },
  {
    path: '/bindCompany',
    name: 'BindCompany',
    meta: { title: i18n.t('绑定企业') },
    component: () => import('@/views/bindCompany'),
  },
  {
    path: '/appointment',
    name: 'Appointment',
    component: () => import('@/views/appointment'),
  },
  {
    path: '/notice',
    name: 'Notice',
    meta: { title: i18n.t('通知参会人') },
    component: () => import('@/views/notice'),
  },
  {
    path: '/inform',
    name: 'Inform',
    meta: { title: i18n.t('会议信息') },
    component: () => import('@/views/inform'),
  },
  {
    path: '/checkMeeting',
    name: 'CheckMeeting',
    component: () => import('@/views/checkMeeting'),
  },
  {
    path: '/templateSend',
    name: 'TemplateSend',
    component: () => import('@/views/templateSend'),
  },
  {
    path: '/templateSendSpecial',
    name: 'TemplateSendSpecial',
    component: () => import('@/views/templateSendSpecial'),
  },
  {
    path: '/visitors',
    name: 'Visitors',
    meta: { title: i18n.t('我的访客') },
    component: () => import('@/views/robot/visitors'),
  },
  {
    path: '/visitorInfo/:id?/:token?/:data?',
    name: 'VisitorInfo',
    meta: { title: i18n.t('访客信息') },
    component: () => import('@/views/robot/visitorInfo'),
  },
  {
    path: '/faceTips',
    name: 'FaceTips',
    component: () => import('@/views/robot/faceTips'),
  },
  {
    path: '/linkRobot',
    name: 'LinkRobot',
    component: () => import('@/views/robot/linkRobot'),
  },
  {
    path: '/newInvitation',
    name: 'NewInvitation',
    meta: { title: i18n.t('新建邀约'), keepAlive: true },
    component: () => import('@/views/robot/newInvitation'),
  },
  {
    path: '/publicnewInvitation',
    name: 'PublicnewInvitation',
    meta: { title: i18n.t('访客信息登记') },
    component: () => import('@/views/robot/publicnewInvitation'),
  },
  {
    path: '/searchSchedule',
    name: 'SearchSchedule',
    meta: { title: i18n.t('查询日程') },
    component: () => import('@/views/robot/searchSchedule'),
  },
  {
    path: '/createSchedule',
    name: 'CreateSchedule',
    meta: { title: i18n.t('创建日程') },
    component: () => import('@/views/robot/createSchedule'),
  },
  {
    path: '/scheduleInfo',
    name: 'scheduleInfo',
    meta: { title: i18n.t('日程详情') },
    component: () => import('@/views/robot/scheduleInfo'),
  },
  {
    // 工位预约列表查询页面
    path: '/station',
    name: 'Station',
    meta: { title: i18n.t('工位预约') },
    component: () => import('@/views/station'),
  },
  {
    // 工位预约配置页面
    path: '/station/stationAppointment',
    name: 'stationAppointment',
    // meta: { title: '我的工位' },
    component: () => import('@/views/station/stationAppointmentSetting'),
  },
  {
    path: '/station/myStation',
    name: 'MyStation',
    meta: { title: i18n.t('我的工位') },
    component: () => import('@/views/station/myStation'),
  },
  {
    path: '/station/stationInfo',
    name: 'StationInfo',
    meta: { title: i18n.t('预约信息') },
    component: () => import('@/views/station/stationInfo'),
  },
  {
    path: '/visitorInvitationBySelf',
    name: 'VisitorInvitationBySelf',
    component: () => import('@/views/robot/visitorInvitationBySelf'),
  },
  {
    path: '/publicVisitorInvitationBySelf',
    name: 'PublicVisitorInvitationBySelf',
    component: () => import('@/views/robot/publicVisitorInvitationBySelf'),
  },
  {
    // 素材详情页面
    path: '/banners/:id?',
    name: 'Banner',
    meta: { title: ' ' },
    component: () => import('@/views/robot/banners'),
  },
  {
    path: '/visitorInvitation/:id?',
    name: 'VisitorInvitation',
    component: () => import('@/views/robot/visitorInvitation'),
    beforeEnter: async (to, from, next) => {
      if (to.query.shareDate) {
        if (dayjs().valueOf() - dayjs(to.query.shareDate).valueOf() > 60 * 1000 * 60 * 24) {
          next({
            path: `/visitorInvitation`,
            query: {
              localLanguage: to.query.localLanguage,
              intervieweeId: to.query.intervieweeId,
              address: to.query.address,
              registerMode: to.query.registerMode,
              intervieweeName: to.query.intervieweeName,
              spaceName: to.query.spaceName,
              robotLocation: to.query.robotLocation,
              ifDisabled: true,
            },
          })
          return
        }
      }
      try {
        if (to.query.shareId) {
          const response = await getVisitByShareId({
            shareId: to.query.shareId + ':' + to.query.id,
          })

          if (response) {
            next({
              path: `/visitorInvitation`,
              query: {
                localLanguage: to.query.localLanguage,
                data: JSON.stringify(response),
                companyCode: to.query.companyCode,
                companyId: to.query.companyId,
                intervieweeName: to.query.intervieweeName,
                intervieweeId: to.query.intervieweeId,
                address: to.query.address,
                registerMode: to.query.registerMode,
                spaceName: to.query.spaceName,
                robotLocation: to.query.robotLocation,
              },
            })
          } else {
            next({
              path: '/newInvitation',
              query: {
                localLanguage: to.query.localLanguage,
                shareId: to.query.shareId,
                id: to.query.id || to.params.id,
                name: to.query.name,
                companyId: to.query.companyId,
                companyCode: to.query.companyCode,
                intervieweeName: to.query.intervieweeName,
                intervieweeId: to.query.intervieweeId,
                address: to.query.address,
                registerMode: to.query.registerMode,
                spaceName: to.query.spaceName,
                robotLocation: to.query.robotLocation,
              },
            })
          }
        } else {
          next()
        }
      } catch (error) {
        next({
          path: `/visitorInvitation`,
          query: { ifDisabled: true },
        })
      }
    },
  },
  {
    path: '/sendInvitation',
    name: 'SendInvitation',
    meta: { title: i18n.t('发送邀约链接') },
    component: () => import('@/views/robot/sendInvitation'),
  },

  {
    path: '/faceCollection',
    name: 'faceCollection',
    meta: { title: i18n.t('人脸采集') },
    component: () => import('@/views/faceCollection'),
  },
  // {
  //   path: '/addressBook',
  //   name: 'addressBook',
  //   meta: { title: '组织成员' },
  //   component: () => import('@/views/addressBook'),
  //   beforeEnter(to, from, next) {
  //     if (localStorage.getItem('user') !== 'undefined' && localStorage.getItem('user') != null) {
  //       next()
  //     } else {
  //       next('/login')
  //     }
  //   },
  // },
  {
    path: '/electronickey',
    name: 'electronickey',
    meta: { title: i18n.t('我的电子钥匙') },
    component: () => import('@/views/electronickey'),
  },
  {
    path: '/userDetail',
    name: 'userDetail',
    meta: { title: i18n.t('个人信息') },
    props: true,
    component: () => import('@/views/addressBook/userDetail.vue'),
  },
  {
    path: '/visitor/apply/:companyId',
    name: 'visitorApply',
    component: () => import('@/views/visitor/apply'),
  },
  {
    path: '/visitor/group-apply/:companyId',
    name: 'groupApply',
    component: () => import('@/views/visitor/GroupApply'),
  },
  {
    path: '/visitor/introduction/:companyId',
    name: 'introduction',
    component: () => import('@/views/visitor/introduction'),
  },
  {
    path: '/visitor/pass/',
    name: 'visitorPass',
    component: () => import('@/views/visitor/pass'),
  },
  {
    path: '/exhibition/vant',
    name: 'exhibition',
    component: () => import('@/views/exhibition/vant'),
  },
  {
    path: '/playsource',
    name: 'playsource',
    component: () => import('@/views/playSource'),
  },
  {
    path: '/persionInfo',
    name: 'persionInfo',
    component: () => import('@/views/persionInfo'),
  },
  {
    path: '/persionalName',
    name: 'persionalName',
    component: () => import('@/views/persionalName'),
  },
  {
    path: '/nickName',
    name: 'nickName',
    component: () => import('@/views/nickName'),
  },
  {
    path: '/persionalEmail',
    name: 'persionalEmail',
    component: () => import('@/views/persionalEmail'),
  },
  {
    //待办
    path: '/representative',
    name: 'Representative',
    meta: { title: i18n.t('待办') },
    component: () => import('@/views/representative'),
  },
  {
    //审批待办详情
    path: '/approveInforRead',
    name: 'ApproveInforRead',
    meta: { title: i18n.t('待办详情') },
    component: () => import('@/views/approveInforRead'),
  },
  // {
  //   //会务待办详情
  //   path: '/meetingAffairs',
  //   name: 'MeetingAffairs',
  //   meta: { title: '待办详情' },
  //   component: () => import('@/views/meetingAffairs'),
  // },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

export default router
